/* Hand-written GraphQL documents for PriceEdition (CONF-106 project C).
   Mirrors catalogOps.js; regenerate/replace if codegen is re-run. */

export const createPriceEdition = /* GraphQL */ `
  mutation CreatePriceEdition($input: CreatePriceEditionInput!) {
    createPriceEdition(input: $input) {
      id vendor editionNumber asOf sheet sheetFormat publishedAt publishedBy sourceNote appVersion
    }
  }
`;

export const priceEditionsByVendor = /* GraphQL */ `
  query PriceEditionsByVendor(
    $vendor: String!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String
  ) {
    priceEditionsByVendor(
      vendor: $vendor, sortDirection: $sortDirection, limit: $limit, nextToken: $nextToken
    ) {
      items {
        id vendor editionNumber asOf sheet sheetFormat publishedAt publishedBy sourceNote appVersion
      }
      nextToken
    }
  }
`;
